import React from 'react'
import styled from 'styled-components'
import { device, Button, Grey_, IconSvg, Main_, Red_ } from 'monica-alexandria'
import { NifflerSvg } from '../../../svg/NifflerSvg'
import { useTranslation } from 'react-i18next';

const CrmSelectActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CrmActionsRight = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1rem;

  .selectedRange {
    border: 2px solid var(--main);
  }

  @media ${device.md} {
    display: ${(p) => (p.active ? "none" : "flex")};

    .FiltersBtn span {
      display: none;
    }
  }
`;

const MobileOnlyActions = styled.div`
  display: none;

  @media ${device.md} {
    display: block;
  }
`;

const DesktopOnlyActions = styled.div`
  display: block;

  @media ${device.md} {
    display: none;
  }
`;

const MobileOnlyMenuItem = styled.div`
  display: none;

  @media ${device.md} {
    display: block;
  }
`;

const MobileShareMenuAction = styled.button`
  width: 100%;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.color};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  padding: 1.1rem 1.3rem;
  border-radius: var(--smallRadius);
  cursor: pointer;

  &:hover {
    background: ${(p) => p.theme.low};
  }
`;

const MobileShareMenuLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    width: 1.8rem;
    fill: ${(p) => p.theme.color};
  }

  h5 {
    font-size: var(--normalText);
    color: ${(p) => p.theme.color};
  }
`;

const MobileShareMenuAvatars = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0;
`;

const MobileShareMenuAvatar = styled.div`
  width: 2.8rem;
  height: 2.8rem;
  min-width: 2.8rem;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid ${(p) => p.theme.low};
  margin-left: ${(p) => (p.index === 0 ? "0" : "-0.55rem")};
  background: ${(p) => p.background || "var(--main)"};

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  p {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 700;
    line-height: 1;
    color: var(--white);
  }
`;

const MobileMenuGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.4rem 0;
`;

const MobileMenuDivider = styled.div`
  height: 1px;
  margin: 0.2rem 1.2rem;
  background: ${(p) => p.theme.low};
  opacity: 0.9;
`;

const CrmMoreActions = styled.div`
  position: relative;
`;

const CrmMoreActionsOptions = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 11;
  background: ${(p) => p.theme.mid};
  color: ${(p) => p.theme.color};
  border-radius: var(--smallRadius);
  display: flex;
  flex-direction: column;
  border: 1px solid ${(p) => p.theme.low};

  .Grey {
    border-radius: var(--smallRadius);
  }
`;

const CrmActions = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: right;
  gap: 4rem;
  width: 100%;

  .FormGroup {
    width: 100%;
  }

  @media ${device.md} {
    gap: 0.5rem;

    button span {
      display: none;
    }
  }

  @media ${device.sm} {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
    justify-content: flex-end;
  }
`;

const CrmView = styled.div`
  display: flex;
  align-items: center;
  border-radius: var(--normalRadius);
  padding: 4px;
  background: ${(props) => props.theme.mid};
  box-shadow: ${(props) => props.theme.in};
  gap: 4px;

  @media ${device.md} {
    display: ${(props) => (props.hideOnMobile ? "none" : "flex")};
  }
`;

const CrmViewItem = styled(Button)`
  background: ${(p) => (p.active ? "var(--main)" : "transparent")};
  border-radius: var(--normalRadius);

  span {
    color: ${(p) => (p.active ? "var(--white)" : p.theme.color)};
  }

  svg {
    width: 2rem;
    transition: 0.25s ease;
    fill: ${(p) => (p.active ? "var(--white)" : p.theme.color)};
  }

  &:hover {
    background: ${(p) => (p.active ? "var(--main)" : "rgba(0,0,0,0.05)")};
  }
`;

const BulkModeActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const BulkActionState = styled.div`
  opacity: ${(props) => (props.active ? 1 : 0.45)};
  pointer-events: ${(props) => (props.active ? "auto" : "none")};
  transition: opacity 0.2s ease;
`;

export default function Crm_Board_Actions({
  isSidequest,
  selectionMode,
  view,
  setView,
  bulkActionLoading,
  exitSelectionMode,
  allVisibleSelected,
  toggleSelectAllVisible,
  selectedLeadIds,
  setConfirmBulkAction,
  newActionsRef,
  moreActions,
  setMoreActions,
  openAddLead,
  columnOrder,
  setIsSliderOpen,
  dateFilters,
  setDateFilters,
  activeFilterCount,
  setSelectionMode,
  desktopMoreActionsRef,
  mobileMoreActionsRef,
  get_all_leads,
  isBoardOwner,
  openSharePanel,
  mobileOwnerPreview,
  mobileCollaboratorPreview,
  getRenderableEmail,
  getCollaboratorAvatarSrc,
}) {

  const {t} = useTranslation();
  return (
    <CrmSelectActions>
      <CrmView hideOnMobile={selectionMode}>
        <CrmViewItem size="small" active={view === "kanban"} onClick={() => setView("kanban")}>
          <NifflerSvg Icon="Board" />
        </CrmViewItem>

        <CrmViewItem size="small" active={view === "table"} onClick={() => setView("table")}>
          <NifflerSvg Icon="Table" />
        </CrmViewItem>

      </CrmView>

      <CrmActionsRight>
        {selectionMode ? (
          <BulkModeActions>
            <Grey_
              noPadding
              size="small"
              iconLeft="Xicon"
              onClick={exitSelectionMode}
              disabled={bulkActionLoading}
            />
            <Grey_
              text={allVisibleSelected ? t("Deselect visible") : t("Select all")}
              noPadding
              size="small"
              onClick={() => toggleSelectAllVisible()}
              disabled={!columnOrder.length || bulkActionLoading}
            />
            <BulkActionState active={selectedLeadIds.length > 0 && !bulkActionLoading}>
              <Grey_
                text={t("Archive")}
                iconRight="Folder"
                noPadding
                size="small"
                onClick={() => setConfirmBulkAction("archive")}
              />
            </BulkActionState>
            <BulkActionState active={selectedLeadIds.length > 0 && !bulkActionLoading}>
              <Red_
                text={bulkActionLoading ? t("Working...") : t("Delete permanently")}
                iconRight="Delete"
                size="small"
                onClick={() => setConfirmBulkAction("delete")}
              />
            </BulkActionState>
          </BulkModeActions>
        ) : (
          <>
            <CrmMoreActions title={t("Add")} ref={newActionsRef}>
              <Main_
                className="addleadbutton"
                onClick={() => setMoreActions(!moreActions ? "new" : false)}
                iconLeft="Add"
                size="small"
              />
              {moreActions === "new" ? (
                <CrmMoreActionsOptions>
                  <Grey_ text={t("New lead")} iconRight="Add" noPadding onClick={() => openAddLead(columnOrder[0])} />
                  <Grey_ text={t("Import file")} iconRight="Upload" noPadding onClick={() => setIsSliderOpen("import")} />
                </CrmMoreActionsOptions>
              ) : null}
            </CrmMoreActions>

            <DesktopOnlyActions>
              <div title={t("Filters")}>
                <Grey_
                  className="FiltersBtn"
                  text={activeFilterCount ? String(activeFilterCount) : ""}
                  iconLeft="Filter"
                  size="small"
                  onClick={() => setDateFilters({ ...dateFilters, slider: true })}
                />
              </div>
            </DesktopOnlyActions>

            <Grey_
              text={t("Select")}
              size="small"
              onClick={() => {
                setMoreActions(false);
                setSelectionMode(true);
              }}
            />

            <DesktopOnlyActions>
              <CrmMoreActions title={t("More actions")} ref={desktopMoreActionsRef}>
                <Grey_ text={t("")} iconRight="More" noPadding onClick={() => setMoreActions(!moreActions ? "more" : false)} />
                {moreActions === "more" ? (
                  <CrmMoreActionsOptions>
                    <Grey_ text={t("Archived")} iconRight="Folder" noPadding onClick={() => setIsSliderOpen("archived")} />
                    {!isSidequest ? <Grey_ text={t("Restore")} iconRight="Undo" noPadding onClick={() => setIsSliderOpen("restore")} /> : null}
                    <Grey_ text={t("Export")} iconRight="Download" noPadding onClick={get_all_leads} />
                  </CrmMoreActionsOptions>
                ) : null}
              </CrmMoreActions>
            </DesktopOnlyActions>

            <MobileOnlyActions>
              <CrmMoreActions title={t("More actions")} ref={mobileMoreActionsRef}>
                <Grey_ text={t("")} iconRight="More" noPadding onClick={() => setMoreActions(!moreActions ? "more-mobile" : false)} />
                {moreActions === "more-mobile" ? (
                  <CrmMoreActionsOptions>
                    <MobileMenuGroup>
                      {isBoardOwner ? (
                        <MobileOnlyMenuItem>
                          <MobileShareMenuAction
                            onClick={() => {
                              setMoreActions(false);
                              openSharePanel();
                            }}
                          >
                            <MobileShareMenuAvatars>
                              {mobileOwnerPreview.visibleUsers.map((userValue, index) => (
                                <MobileShareMenuAvatar
                                  key={`${String(userValue?.userId || getRenderableEmail(userValue?.email) || index)}-mobile-share`}
                                  index={index}
                                  background={userValue?.isOwner ? "var(--main)" : "#f4c7a1"}
                                >
                                  <img
                                    src={getCollaboratorAvatarSrc(userValue)}
                                    alt={userValue?.name || getRenderableEmail(userValue?.email)}
                                  />
                                </MobileShareMenuAvatar>
                              ))}
                              {mobileOwnerPreview.hasOverflow ? (
                                <MobileShareMenuAvatar
                                  index={mobileOwnerPreview.visibleUsers.length}
                                  background="var(--greyDark)"
                                >
                                  <p>...</p>
                                </MobileShareMenuAvatar>
                              ) : null}
                            </MobileShareMenuAvatars>
                            <MobileShareMenuLeft>
                              <h5>{t("Share")}</h5>
                              <IconSvg Icon="AddUser" />
                            </MobileShareMenuLeft>
                          </MobileShareMenuAction>
                        </MobileOnlyMenuItem>
                      ) : (
                        <MobileOnlyMenuItem>
                          <MobileShareMenuAction
                            onClick={() => {
                              setMoreActions(false);
                              openSharePanel("collaborators");
                            }}
                          >
                            <MobileShareMenuAvatars>
                              {mobileCollaboratorPreview.visibleUsers.map((userValue, index) => (
                                <MobileShareMenuAvatar
                                  key={`${String(userValue?.userId || getRenderableEmail(userValue?.email) || index)}-mobile-collaborators`}
                                  index={index}
                                  background={userValue?.isOwner ? "var(--main)" : "#f4c7a1"}
                                >
                                  <img
                                    src={getCollaboratorAvatarSrc(userValue)}
                                    alt={userValue?.name || getRenderableEmail(userValue?.email)}
                                  />
                                </MobileShareMenuAvatar>
                              ))}
                              {mobileCollaboratorPreview.hasOverflow ? (
                                <MobileShareMenuAvatar
                                  index={mobileCollaboratorPreview.visibleUsers.length}
                                  background="var(--greyDark)"
                                >
                                  <p>...</p>
                                </MobileShareMenuAvatar>
                              ) : null}
                            </MobileShareMenuAvatars>
                            <MobileShareMenuLeft>
                              <h5>{t("Collaborators")}</h5>
                              <IconSvg Icon="User" />
                            </MobileShareMenuLeft>
                          </MobileShareMenuAction>
                        </MobileOnlyMenuItem>
                      )}
                    </MobileMenuGroup>

                    <MobileMenuDivider />

                    <MobileMenuGroup>
                      <MobileOnlyMenuItem>
                        <Grey_ text={`${t("Filters")}${activeFilterCount ? ` (${activeFilterCount})` : ""}`} iconRight="Filter" noPadding onClick={() => setDateFilters({ ...dateFilters, slider: true })} />
                      </MobileOnlyMenuItem>
                      <Grey_ text={t("Archived")} iconRight="Folder" noPadding onClick={() => setIsSliderOpen("archived")} />
                      <Grey_ text={t("Export")} iconRight="Download" noPadding onClick={get_all_leads} />
                    </MobileMenuGroup>
                  </CrmMoreActionsOptions>
                ) : null}
              </CrmMoreActions>
            </MobileOnlyActions>
          </>
        )}
      </CrmActionsRight>
    </CrmSelectActions>
  );
}
